// Mock Data for TaskFlow System

export const mockMembers = [
  // Squad - Luiz Santos
  {
    id: '1',
    name: 'Amanda Vieira',
    profession: 'Governança de Dados',
    email: 'amanda.vieira@example.com',
    avatar_color: 'blue',
    active: true,
    created_date: new Date('2024-01-15').toISOString()
  },
  {
    id: '2',
    name: 'Gabriel Faria',
    profession: 'Analista de Dados',
    email: 'gabriel.faria@example.com',
    avatar_color: 'green',
    active: true,
    created_date: new Date('2024-01-16').toISOString()
  },
  {
    id: '3',
    name: 'Thais Correa',
    profession: 'Engenheiro de Dados',
    email: 'thais.correa@example.com',
    avatar_color: 'purple',
    active: true,
    created_date: new Date('2024-01-17').toISOString()
  },
  {
    id: '4',
    name: 'João Domingues',
    profession: 'Ciência de Dados',
    email: 'joao.domingues@example.com',
    avatar_color: 'orange',
    active: true,
    created_date: new Date('2024-01-18').toISOString()
  },
  {
    id: '5',
    name: 'Renan Faria',
    profession: 'Engenheiro de Dados',
    email: 'renan.faria@example.com',
    avatar_color: 'red',
    active: true,
    created_date: new Date('2024-01-19').toISOString()
  },
  // Squad - Jessica Marcondes
  {
    id: '6',
    name: 'Milla Sousa',
    profession: 'Governança de Dados',
    email: 'milla.sousa@example.com',
    avatar_color: 'indigo',
    active: true,
    created_date: new Date('2024-01-20').toISOString()
  },
  {
    id: '7',
    name: 'Gustavo Castro',
    profession: 'Analista de Dados',
    email: 'gustavo.castro@example.com',
    avatar_color: 'blue',
    active: true,
    created_date: new Date('2024-01-21').toISOString()
  },
  {
    id: '8',
    name: 'André Machado',
    profession: 'Engenheiro de Dados',
    email: 'andre.machado@example.com',
    avatar_color: 'green',
    active: true,
    created_date: new Date('2024-01-22').toISOString()
  },
  {
    id: '9',
    name: 'Fernanda Gubert',
    profession: 'Ciência de Dados',
    email: 'fernanda.gubert@example.com',
    avatar_color: 'purple',
    active: true,
    created_date: new Date('2024-01-23').toISOString()
  },
  {
    id: '10',
    name: 'Vitor Silva',
    profession: 'Engenheiro de Dados',
    email: 'vitor.silva@example.com',
    avatar_color: 'orange',
    active: true,
    created_date: new Date('2024-01-24').toISOString()
  },
  // Sustentação & Qualidade
  {
    id: '11',
    name: 'Paola Marsura',
    profession: 'Governança de Dados',
    email: 'paola.marsura@example.com',
    avatar_color: 'red',
    active: true,
    created_date: new Date('2024-01-25').toISOString()
  },
  {
    id: '12',
    name: 'Carlos Eduardo',
    profession: 'Engenheiro de Dados',
    email: 'carlos.eduardo@example.com',
    avatar_color: 'indigo',
    active: true,
    created_date: new Date('2024-01-26').toISOString()
  },
  {
    id: '13',
    name: 'Artur Lauth',
    profession: 'Engenheiro de Dados',
    email: 'artur.lauth@example.com',
    avatar_color: 'blue',
    active: true,
    created_date: new Date('2024-01-27').toISOString()
  },
  {
    id: '14',
    name: 'Fernando Ce',
    profession: 'Analista de Dados',
    email: 'fernando.ce@example.com',
    avatar_color: 'green',
    active: true,
    created_date: new Date('2024-01-28').toISOString()
  },
  {
    id: '15',
    name: 'Arcer Soluções Tecnológicas',
    profession: 'Desenvolvedores',
    email: 'arcer@example.com',
    avatar_color: 'purple',
    active: true,
    created_date: new Date('2024-01-29').toISOString()
  }
];

export const mockTeams = [
  {
    id: 't1',
    name: 'Squad - Luiz Santos',
    description: 'Squad responsável por projetos de dados e analytics',
    color: 'blue',
    members: ['1', '2', '3', '4', '5'],
    active: true,
    created_date: new Date('2024-02-01').toISOString()
  },
  {
    id: 't2',
    name: 'Squad - Jessica Marcondes',
    description: 'Squad focado em engenharia e ciência de dados',
    color: 'purple',
    members: ['6', '7', '8', '9', '10'],
    active: true,
    created_date: new Date('2024-02-02').toISOString()
  },
  {
    id: 't3',
    name: 'Sustentação & Qualidade',
    description: 'Time responsável pela manutenção e qualidade dos dados',
    color: 'green',
    members: ['11', '12', '13', '14', '15'],
    active: true,
    created_date: new Date('2024-02-03').toISOString()
  }
];

export const mockTasks = [
  // Squad - Luiz Santos
  {
    id: 'task1',
    title: 'Implementar pipeline de ETL para dados de vendas',
    description: 'Criar pipeline automatizado para extrair, transformar e carregar dados de vendas no data warehouse',
    status: 'in_progress',
    priority: 'high',
    assignees: ['3', '5'],
    due_date: '2025-12-20',
    tags: ['etl', 'pipeline', 'vendas'],
    order: 0,
    estimated_hours: 24,
    started_at: new Date('2025-12-08T09:00:00').toISOString(),
    subtasks: [
      { id: 'st1', title: 'Mapear fontes de dados', completed: true, estimated_hours: 4 },
      { id: 'st2', title: 'Criar scripts de extração', completed: true, estimated_hours: 8 },
      { id: 'st3', title: 'Implementar transformações', completed: false, estimated_hours: 12 }
    ],
    team_id: 't1',
    created_date: new Date('2025-12-01').toISOString(),
    created_by: 'amanda.vieira@example.com'
  },
  {
    id: 'task2',
    title: 'Dashboard de métricas de negócio',
    description: 'Desenvolver dashboard interativo com principais KPIs do negócio',
    status: 'review',
    priority: 'urgent',
    assignees: ['2', '4'],
    due_date: '2025-12-15',
    tags: ['dashboard', 'analytics', 'kpi'],
    order: 0,
    estimated_hours: 16,
    started_at: new Date('2025-12-05T10:00:00').toISOString(),
    subtasks: [
      { id: 'st4', title: 'Definir métricas principais', completed: true, estimated_hours: 4 },
      { id: 'st5', title: 'Criar visualizações', completed: true, estimated_hours: 12 }
    ],
    team_id: 't1',
    created_date: new Date('2025-12-02').toISOString(),
    created_by: 'gabriel.faria@example.com'
  },
  {
    id: 'task3',
    title: 'Documentação de políticas de governança',
    description: 'Elaborar documentação completa das políticas de governança de dados',
    status: 'todo',
    priority: 'medium',
    assignees: ['1'],
    due_date: '2025-12-25',
    tags: ['governança', 'documentação'],
    order: 0,
    estimated_hours: 12,
    subtasks: [],
    team_id: 't1',
    created_date: new Date('2025-12-03').toISOString(),
    created_by: 'amanda.vieira@example.com'
  },

  // Squad - Jessica Marcondes
  {
    id: 'task4',
    title: 'Modelo de ML para previsão de churn',
    description: 'Desenvolver modelo de machine learning para prever churn de clientes',
    status: 'in_progress',
    priority: 'high',
    assignees: ['9', '10'],
    due_date: '2025-12-28',
    tags: ['machine-learning', 'churn', 'previsão'],
    order: 0,
    estimated_hours: 40,
    started_at: new Date('2025-12-07T08:00:00').toISOString(),
    subtasks: [
      { id: 'st6', title: 'Análise exploratória de dados', completed: true, estimated_hours: 8 },
      { id: 'st7', title: 'Feature engineering', completed: true, estimated_hours: 12 },
      { id: 'st8', title: 'Treinamento de modelos', completed: false, estimated_hours: 12 },
      { id: 'st9', title: 'Validação e deploy', completed: false, estimated_hours: 8 }
    ],
    team_id: 't2',
    created_date: new Date('2025-11-28').toISOString(),
    created_by: 'fernanda.gubert@example.com'
  },
  {
    id: 'task5',
    title: 'Otimização de queries no data warehouse',
    description: 'Revisar e otimizar queries lentas identificadas no monitoramento',
    status: 'done',
    priority: 'medium',
    assignees: ['8'],
    due_date: '2025-12-10',
    tags: ['performance', 'otimização', 'sql'],
    order: 0,
    estimated_hours: 8,
    started_at: new Date('2025-12-04T09:00:00').toISOString(),
    subtasks: [],
    team_id: 't2',
    created_date: new Date('2025-12-04').toISOString(),
    created_by: 'andre.machado@example.com'
  },
  {
    id: 'task6',
    title: 'Auditoria de qualidade de dados',
    description: 'Realizar auditoria completa na qualidade dos dados de clientes',
    status: 'todo',
    priority: 'high',
    assignees: ['6', '7'],
    due_date: '2025-12-22',
    tags: ['qualidade', 'auditoria', 'clientes'],
    order: 1,
    estimated_hours: 20,
    subtasks: [
      { id: 'st10', title: 'Definir critérios de qualidade', completed: false, estimated_hours: 4 },
      { id: 'st11', title: 'Executar testes automatizados', completed: false, estimated_hours: 8 },
      { id: 'st12', title: 'Relatório de inconsistências', completed: false, estimated_hours: 8 }
    ],
    team_id: 't2',
    created_date: new Date('2025-12-05').toISOString(),
    created_by: 'milla.sousa@example.com'
  },

  // Sustentação & Qualidade
  {
    id: 'task7',
    title: 'Correção de bugs críticos no pipeline de produção',
    description: 'Identificar e corrigir bugs que estão causando falhas no pipeline',
    status: 'in_progress',
    priority: 'urgent',
    assignees: ['12', '13', '15'],
    due_date: '2025-12-13',
    tags: ['bugs', 'crítico', 'pipeline'],
    order: 0,
    estimated_hours: 16,
    started_at: new Date('2025-12-10T14:00:00').toISOString(),
    subtasks: [
      { id: 'st13', title: 'Análise de logs de erro', completed: true, estimated_hours: 4 },
      { id: 'st14', title: 'Correção de bugs', completed: false, estimated_hours: 8 },
      { id: 'st15', title: 'Testes de regressão', completed: false, estimated_hours: 4 }
    ],
    team_id: 't3',
    created_date: new Date('2025-12-10').toISOString(),
    created_by: 'carlos.eduardo@example.com'
  },
  {
    id: 'task8',
    title: 'Implementar testes automatizados de qualidade',
    description: 'Criar suite de testes automatizados para validação de dados',
    status: 'backlog',
    priority: 'medium',
    assignees: ['13', '14'],
    due_date: '2025-12-30',
    tags: ['testes', 'automação', 'qualidade'],
    order: 0,
    estimated_hours: 24,
    subtasks: [],
    team_id: 't3',
    created_date: new Date('2025-12-06').toISOString(),
    created_by: 'artur.lauth@example.com'
  },
  {
    id: 'task9',
    title: 'Atualização de políticas de retenção de dados',
    description: 'Revisar e atualizar políticas de retenção conforme LGPD',
    status: 'review',
    priority: 'high',
    assignees: ['11'],
    due_date: '2025-12-18',
    tags: ['governança', 'lgpd', 'retenção'],
    order: 0,
    estimated_hours: 10,
    started_at: new Date('2025-12-09T11:00:00').toISOString(),
    subtasks: [
      { id: 'st16', title: 'Análise de requisitos legais', completed: true, estimated_hours: 4 },
      { id: 'st17', title: 'Atualização de documentação', completed: true, estimated_hours: 6 }
    ],
    team_id: 't3',
    created_date: new Date('2025-12-07').toISOString(),
    created_by: 'paola.marsura@example.com'
  },
  {
    id: 'task10',
    title: 'Monitoramento e alertas de performance',
    description: 'Configurar sistema de monitoramento e alertas para pipelines',
    status: 'todo',
    priority: 'medium',
    assignees: ['12', '15'],
    due_date: '2025-12-27',
    tags: ['monitoramento', 'performance', 'alertas'],
    order: 1,
    estimated_hours: 18,
    subtasks: [],
    team_id: 't3',
    created_date: new Date('2025-12-08').toISOString(),
    created_by: 'carlos.eduardo@example.com'
  }
];

export const mockHistory = [
  // Task 1 - Pipeline ETL
  {
    id: 'h1',
    task_id: 'task1',
    task_title: 'Implementar pipeline de ETL para dados de vendas',
    action: 'created',
    field_changed: null,
    old_value: null,
    new_value: null,
    changed_by: 'amanda.vieira@example.com',
    created_date: new Date('2025-12-01T09:00:00').toISOString()
  },
  {
    id: 'h2',
    task_id: 'task1',
    task_title: 'Implementar pipeline de ETL para dados de vendas',
    action: 'status_changed',
    field_changed: 'status',
    old_value: 'backlog',
    new_value: 'in_progress',
    changed_by: 'thais.correa@example.com',
    created_date: new Date('2025-12-08T09:00:00').toISOString()
  },
  {
    id: 'h3',
    task_id: 'task1',
    task_title: 'Implementar pipeline de ETL para dados de vendas',
    action: 'assignee_changed',
    field_changed: 'assignees',
    old_value: 'Thais Correa',
    new_value: 'Thais Correa, Renan Faria',
    changed_by: 'amanda.vieira@example.com',
    created_date: new Date('2025-12-09T10:30:00').toISOString()
  },

  // Task 2 - Dashboard
  {
    id: 'h4',
    task_id: 'task2',
    task_title: 'Dashboard de métricas de negócio',
    action: 'created',
    field_changed: null,
    old_value: null,
    new_value: null,
    changed_by: 'gabriel.faria@example.com',
    created_date: new Date('2025-12-02T10:00:00').toISOString()
  },
  {
    id: 'h5',
    task_id: 'task2',
    task_title: 'Dashboard de métricas de negócio',
    action: 'status_changed',
    field_changed: 'status',
    old_value: 'todo',
    new_value: 'in_progress',
    changed_by: 'gabriel.faria@example.com',
    created_date: new Date('2025-12-05T10:00:00').toISOString()
  },
  {
    id: 'h6',
    task_id: 'task2',
    task_title: 'Dashboard de métricas de negócio',
    action: 'status_changed',
    field_changed: 'status',
    old_value: 'in_progress',
    new_value: 'review',
    changed_by: 'joao.domingues@example.com',
    created_date: new Date('2025-12-11T15:00:00').toISOString()
  },

  // Task 4 - ML Model
  {
    id: 'h7',
    task_id: 'task4',
    task_title: 'Modelo de ML para previsão de churn',
    action: 'created',
    field_changed: null,
    old_value: null,
    new_value: null,
    changed_by: 'fernanda.gubert@example.com',
    created_date: new Date('2025-11-28T08:00:00').toISOString()
  },
  {
    id: 'h8',
    task_id: 'task4',
    task_title: 'Modelo de ML para previsão de churn',
    action: 'status_changed',
    field_changed: 'status',
    old_value: 'backlog',
    new_value: 'in_progress',
    changed_by: 'fernanda.gubert@example.com',
    created_date: new Date('2025-12-07T08:00:00').toISOString()
  },

  // Task 5 - Otimização
  {
    id: 'h9',
    task_id: 'task5',
    task_title: 'Otimização de queries no data warehouse',
    action: 'created',
    field_changed: null,
    old_value: null,
    new_value: null,
    changed_by: 'andre.machado@example.com',
    created_date: new Date('2025-12-04T09:00:00').toISOString()
  },
  {
    id: 'h10',
    task_id: 'task5',
    task_title: 'Otimização de queries no data warehouse',
    action: 'status_changed',
    field_changed: 'status',
    old_value: 'todo',
    new_value: 'in_progress',
    changed_by: 'andre.machado@example.com',
    created_date: new Date('2025-12-04T09:00:00').toISOString()
  },
  {
    id: 'h11',
    task_id: 'task5',
    task_title: 'Otimização de queries no data warehouse',
    action: 'status_changed',
    field_changed: 'status',
    old_value: 'in_progress',
    new_value: 'done',
    changed_by: 'andre.machado@example.com',
    created_date: new Date('2025-12-10T16:00:00').toISOString()
  },

  // Task 7 - Bugs críticos
  {
    id: 'h12',
    task_id: 'task7',
    task_title: 'Correção de bugs críticos no pipeline de produção',
    action: 'created',
    field_changed: null,
    old_value: null,
    new_value: null,
    changed_by: 'carlos.eduardo@example.com',
    created_date: new Date('2025-12-10T14:00:00').toISOString()
  },
  {
    id: 'h13',
    task_id: 'task7',
    task_title: 'Correção de bugs críticos no pipeline de produção',
    action: 'status_changed',
    field_changed: 'status',
    old_value: 'backlog',
    new_value: 'in_progress',
    changed_by: 'carlos.eduardo@example.com',
    created_date: new Date('2025-12-10T14:00:00').toISOString()
  },
  {
    id: 'h14',
    task_id: 'task7',
    task_title: 'Correção de bugs críticos no pipeline de produção',
    action: 'updated',
    field_changed: 'priority',
    old_value: 'high',
    new_value: 'urgent',
    changed_by: 'paola.marsura@example.com',
    created_date: new Date('2025-12-10T15:30:00').toISOString()
  },

  // Task 9 - LGPD
  {
    id: 'h15',
    task_id: 'task9',
    task_title: 'Atualização de políticas de retenção de dados',
    action: 'created',
    field_changed: null,
    old_value: null,
    new_value: null,
    changed_by: 'paola.marsura@example.com',
    created_date: new Date('2025-12-07T11:00:00').toISOString()
  },
  {
    id: 'h16',
    task_id: 'task9',
    task_title: 'Atualização de políticas de retenção de dados',
    action: 'status_changed',
    field_changed: 'status',
    old_value: 'todo',
    new_value: 'in_progress',
    changed_by: 'paola.marsura@example.com',
    created_date: new Date('2025-12-09T11:00:00').toISOString()
  },
  {
    id: 'h17',
    task_id: 'task9',
    task_title: 'Atualização de políticas de retenção de dados',
    action: 'status_changed',
    field_changed: 'status',
    old_value: 'in_progress',
    new_value: 'review',
    changed_by: 'paola.marsura@example.com',
    created_date: new Date('2025-12-11T09:00:00').toISOString()
  }
];